// @react/hooks/useTag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { tagStore } from '@core/stores';

/**
 * React hook for Tag operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTag } from '@react/hooks';
 *
 * const TagList = observer(() => {
 *   const store = useTag();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTag() {
  return tagStore;
}
